import React from "react"
// MUI
import {Box, Chip, Tooltip, Typography} from "@mui/material"
// Translation
import {useTranslation} from "react-i18next"
// Tokens
import {packagingTokens as tk} from "@/theme/packagingTokens"

// Chip lists stay scannable past this count: render the first
// MAX_VISIBLE_CHIPS entries, collapse the tail into a <MoreChip />.
export const MAX_VISIBLE_CHIPS = 7

type MoreChipProps = {
    // The hidden entries — shown in the tooltip, counted in the label.
    labels: string[]
}

// Tail collapser for chip lists: a dashed "…and X more" chip whose tooltip
// lists the entries that didn't make the visible cut.
export default function MoreChip({labels}: MoreChipProps) {

    const {t} = useTranslation(["common"])

    if (labels.length === 0) return null

    return (
        <Tooltip
            arrow
            placement={"top"}
            title={
                <Box sx={{py: 0.25}}>
                    {labels.map((label, i) => (
                        <Typography key={i} sx={{fontSize: "12px"}}>{label}</Typography>
                    ))}
                </Box>
            }
        >
            <Chip
                label={t("chips_more", {count: labels.length})}
                size={"small"}
                sx={{
                    height: 24,
                    borderRadius: tk.radius.pill,
                    backgroundColor: tk.color.bg,
                    border: `1px dashed ${tk.color.border}`,
                    fontSize: "11.5px",
                    fontWeight: 500,
                    color: tk.color.textTertiary,
                    cursor: "default",
                }}
            />
        </Tooltip>
    )
}
